import { reset, setSliceTabIndex } from '../slices/FJSliceAIPhotoGenerator.js';
import FJUtil from '../../util/FJUtil.js';
import FJLocalStore from '../../store/FJLocalStore.js';
import { AI_GENERATOR_PHOTO_TAB_LIST } from '../../config/dataConfig/FJAIPhotoGeneratorData.js';
import FJAppConfigManager from '../../common/js/FJAppConfigManager.js';
import FJConfig from '../../config/FJConfig.js';
import { setAppTypeAction, setSliceHistoryListAction } from '../slices/FJSliceCommon.js';
import {
    setSliceFilterType,
    setSliceSearchText,
    setSliceListStatus,
    setSliceListPage,
    setSliceListPageSize,
    setSliceListTotal,
} from '../slices/FJSliceAIPhotoGenerator.js';
import FJConstant from '../../constants/FJConstant.js';
import FJNetworkStore from '../../store/FJNetworkStore.js';
import FJActionTextToImage from './FJActionTextToImage.js';
import FJActionAIPhotoEditor from './FJActionAIPhotoEditor.js';
import FJAppConstant from '../../constants/FJAppConstant.js';
import FJActionImageToImage from './FJActionImageToImage.js';

let oldFilterType = null;

const FJActionAIPhotoGenerator = {
    resetAction: function () {
        return dispatch => {
            dispatch(reset());
        };
    },
    initAction: function (app) {
        return async dispatch => {
            const appType = app || FJAppConfigManager.getDefaultType();
            const itemIndex = AI_GENERATOR_PHOTO_TAB_LIST.findIndex(i => i.value === appType);
            dispatch(
                this.changeTabIndexAction(AI_GENERATOR_PHOTO_TAB_LIST[itemIndex], itemIndex, { ignoreTitle: true }),
            );
            await dispatch(FJActionTextToImage.initTextToImageDataAction());

            if (appType === FJAppConstant.AI_PHOTO_EDITOR) {
                dispatch(FJActionAIPhotoEditor.initAIPhotoEditorAction());
            } else if (appType === FJAppConstant.TEXT_TO_IMAGE) {
                dispatch(FJActionTextToImage._loadTextToImageParamsAction());
            } else if (appType === FJAppConstant.IMAGE_TO_IMAGE) {
                dispatch(FJActionImageToImage.loadImageToImagePageAction());
                if (FJUtil.getIsNeedGenerateInImageToImage()) {
                    FJUtil.setIsNeedGenerateInImageToImage(false);
                    dispatch(FJActionImageToImage.generateAction());
                }
            }
        };
    },
    changeTabIndexAction: function (item, index, options = {}) {
        return dispatch => {
            const { ignoreTitle = false } = options;
            dispatch(setSliceTabIndex(index));

            const tabType = AI_GENERATOR_PHOTO_TAB_LIST[index].value;
            FJAppConfigManager.mergeConfig(FJConfig, tabType);
            FJConfig.appType = tabType;
            dispatch(setAppTypeAction(tabType));

            if (!FJUtil.isSpecialPage() && !ignoreTitle) {
                const tag = FJLocalStore.currentTag();
                let linkTag = tag === 'en' ? `` : `/${tag}`;
                const { origin, search } = window.location;
                const href = FJUtil.getAIToolHref(item.name);
                FJUtil.changeLocation(`${origin}${linkTag}${href}${search}`);
                FJUtil.updateDocumentTitle(item.value);
            }
        };
    },

    /**
     * 改变筛选类型
     * @param {string} type 筛选类型
     */
    changeFilterTypeAction: function (type) {
        return dispatch => {
            dispatch(setSliceFilterType(type));
        };
    },

    /**
     * 改变搜索文本
     * @param {string} text 搜索文本
     */
    changeSearchTextAction: function (text) {
        return dispatch => {
            dispatch(setSliceSearchText(text));
        };
    },

    /**
     * 改变列表状态
     * @param {string} status 列表状态
     */
    changeListStatusAction: function (status) {
        return dispatch => {
            dispatch(setSliceListStatus(status));
        };
    },

    /**
     * 改变列表页码
     * @param {number} page 列表页码
     */
    changeListPageAction: function (page) {
        return dispatch => {
            dispatch(setSliceListPage(page));
        };
    },

    /**
     * 改变列表页大小
     * @param {number} pageSize 列表页大小
     */
    changeListPageSizeAction: function (pageSize) {
        return dispatch => {
            dispatch(setSliceListPageSize(pageSize));
        };
    },

    /**
     * 改变列表总条数
     * @param {number} total 列表总条数
     */
    changeListTotalAction: function (total) {
        return dispatch => {
            dispatch(setSliceListTotal(total));
        };
    },

    updateHistoryListAction: function (options = {}) {
        return async (dispatch, getState) => {
            try {
                const { filterType, searchText, listStatus } = getState().aiPhotoGenerator;
                const { page, callback = () => {} } = options;
                if (listStatus === FJConstant.LOADING) {
                    return;
                }

                oldFilterType = filterType;
                if (page === 1) {
                    dispatch(setSliceHistoryListAction([]));
                }

                dispatch(this.changeListStatusAction(FJConstant.LOADING));

                let eventType = '';
                switch (filterType) {
                    case FJConstant.ALL:
                        eventType = '6,3,36';
                        break;
                    case FJConstant.TEXT_TO_IMAGE:
                        eventType = '6';
                        break;
                    case FJConstant.IMAGE_TO_IMAGE:
                        eventType = '3';
                        break;
                    case FJConstant.PHOTO_EDITOR:
                        eventType = '36';
                        break;
                    default:
                }

                const { data, code } = await FJNetworkStore.getAITaskList(eventType, {
                    ...options,
                    search: searchText,
                });
                if (oldFilterType !== filterType) {
                    return;
                }

                if (code === 200) {
                    const list = await FJUtil.parseList(data.list, { type: FJConstant.HISTORY });

                    const historyList = getState().common.historyList;
                    let newList = [];
                    if (page === 1) {
                        newList = list;
                    } else {
                        newList = historyList.concat(list);
                    }
                    dispatch(setSliceHistoryListAction(newList));
                    dispatch(this.changeListPageAction(page));
                    dispatch(this.changeListTotalAction(data.total));
                    dispatch(this.changeListStatusAction(FJConstant.SUCCESS));
                    callback(newList);
                } else {
                    dispatch(this.changeListStatusAction(FJConstant.ERROR));
                }
            } catch (e) {
                dispatch(this.changeListStatusAction(FJConstant.ERROR));
            }
        };
    },
};
export default FJActionAIPhotoGenerator;
